import { useState } from 'react'
import { Link } from '@inertiajs/react'
import AppShell from '../../components/AppShell'
import AgentPageHeader from '../../components/AgentPageHeader'
import UploadedFileCard, { type UploadedFile } from '../../components/UploadedFileCard'
import ExtractionResultCard, { type ExtractionData } from '../../components/ExtractionResultCard'

interface Props {
  title: string
  description: string
  status: string
  upload_url: string
  extract_url: string
  uploaded_file: UploadedFile | null
}

function getCsrfToken(): string {
  return document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? ''
}

export default function Show({ title, description, status, upload_url, extract_url, uploaded_file }: Props) {
  const [extractedData, setExtractedData] = useState<ExtractionData | null>(null)
  const [extracting, setExtracting] = useState(false)
  const [extractionError, setExtractionError] = useState<string | null>(null)

  function handleExtract() {
    if (extracting) return
    setExtractedData(null)
    setExtractionError(null)
    setExtracting(true)

    fetch(extract_url, {
      method: 'POST',
      headers: { 'X-CSRF-Token': getCsrfToken() },
    })
      .then(async (res) => {
        const data = await res.json()
        if (!res.ok) throw new Error(data.error ?? 'Extraction failed')
        setExtractedData(data)
      })
      .catch((err: Error) => setExtractionError(err.message))
      .finally(() => setExtracting(false))
  }

  return (
    <AppShell>
      <div className="max-w-7xl mx-auto px-6 pt-10 pb-16">
        <Link
          href="/apps"
          className="inline-flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-700 transition-colors"
        >
          ← Back to apps
        </Link>

        <AgentPageHeader title={title} description={description} status={status} />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <UploadedFileCard
            uploadedFile={uploaded_file}
            uploadUrl={upload_url}
            onExtract={handleExtract}
            extracting={extracting}
          />
          <ExtractionResultCard
            extractedData={extractedData}
            extracting={extracting}
            error={extractionError}
          />
        </div>
      </div>
    </AppShell>
  )
}
